import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { CloseButton } from "@/components/General/Modal/components/closeButton";
import { ConfirmButton } from "@/components/General/Modal/components/confirmButton";
import { Sheet } from "@/components/General/Modal/components/sheet/sheet.lazy";
import { useModalContext } from "@/components/General/Modal/context/modal.context";
import { getTagIdFor } from "@/utils/tagging/tag.utils";

type Props = {
    className?: string;
    children?: ReactNode;
};

export const ModalSheet = ({ className, children }: Props) => {
    const {
        sheetDetent,
        title,
        subtitle,
        confirmButtonText,
        open,
        active,
        optimisticOpen,
        withFooter,
        closable,
        onClose,
        onCloseEnd,
        onOpenEnd,
        modalType
    } = useModalContext();

    return (
        <Sheet
            className={className}
            sheetDetent={sheetDetent}
            open={open}
            active={active}
            optimisticOpen={optimisticOpen}
            closable={closable}
            onClose={onClose}
            onCloseEnd={onCloseEnd}
            onOpenEnd={onOpenEnd}
            {...getTagIdFor(`modal${modalType ? `-${modalType}` : ""}`)}
        >
            <Sheet.Scrollable>
                {title && (
                    <Sheet.Header className={cn("tw:mb-4 tw:px-4")}>
                        <Sheet.Header.Title>{title}</Sheet.Header.Title>
                        {subtitle && (
                            <Sheet.Header.Subtitle>
                                {subtitle}
                            </Sheet.Header.Subtitle>
                        )}
                    </Sheet.Header>
                )}
                <Sheet.Body>
                    <div className={cn("tw:px-4")}>{children}</div>
                </Sheet.Body>
            </Sheet.Scrollable>
            {withFooter && confirmButtonText && (
                <Sheet.Footer
                    className={cn("tw:px-4 tw:flex tw:w-full tw:items-center", {
                        "tw:justify-between": closable,
                        "tw:justify-end": !closable
                    })}
                >
                    <CloseButton />
                    <ConfirmButton />
                </Sheet.Footer>
            )}
        </Sheet>
    );
};
